module.exports = __webpack_public_path__ + "static/media/ic_follow-link-primary.39c4a552.svg";